<button type="button" class="header-action" aria-haspopup="dialog" title="Support" (click)="toggleDialog()">
  <fa-icon [icon]="['fas', 'circle-info']" aria-hidden="true"></fa-icon> Support
  @if (badgeCount() > 0) {
    <span class="header-badge">{{ badgeCount() }}</span>
  }
</button>

<p-dialog [(visible)]="showDialog" [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  [style]="{ width: '92vw', maxWidth: '760px' }" appendTo="body">
  <ng-template pTemplate="header">
    <div class="flex items-center gap-2 text-base font-semibold">
      <fa-icon [icon]="['fas', 'circle-info']" aria-hidden="true"></fa-icon>
      <span>Supporto</span>
    </div>
  </ng-template>

  <div class="mb-3 mt-2 flex flex-wrap gap-2 border-b border-fq-border-soft pb-3">
    <button type="button" class="fq-btn" [ngClass]="view() === 'new' ? 'fq-btn-primary' : 'fq-btn-outline-primary'" (click)="openView('new')">
      <fa-icon [icon]="['fas', 'plus']" aria-hidden="true"></fa-icon> Nuova segnalazione
    </button>
    <button type="button" class="fq-btn" [ngClass]="view() === 'mine' ? 'fq-btn-primary' : 'fq-btn-outline-primary'" (click)="openView('mine')">
      <fa-icon [icon]="['fas', 'list-check']" aria-hidden="true"></fa-icon> Le mie segnalazioni
      @if (count().mine > 0) {
        <span class="ml-1 inline-flex items-center rounded-full bg-fq-info px-2 py-0.5 text-xs font-bold text-white">{{ count().mine }}</span>
      }
    </button>
    @if (count().canManage) {
      <button type="button" class="fq-btn fq-btn-outline-primary ml-auto" (click)="openManage()">
        <fa-icon [icon]="['fas', 'table-list']" aria-hidden="true"></fa-icon> Gestisci tutte
      </button>
    }
  </div>

  @if (view() === 'new') {
    <fq-support-ticket-form (created)="onTicketCreated()"></fq-support-ticket-form>
  }

  @if (view() === 'mine') {
    <div class="max-h-[60vh] overflow-y-auto">
      @if (loading()) {
        <div class="py-6 text-center text-sm text-fq-text-muted">Caricamento…</div>
      } @else if (tickets().length === 0) {
        <div class="py-6 text-center text-sm text-fq-text-muted">
          Non hai ancora inviato segnalazioni.
        </div>
      } @else {
        <div class="grid gap-3">
          @for (ticket of tickets(); track ticket.id) {
            <div class="rounded-lg border border-fq-border-soft bg-fq-surface p-3">
              <div class="mb-1 flex flex-wrap items-center gap-2">
                <span class="fq-badge" [ngClass]="statusClass(ticket.status)">{{ statusLabel(ticket.status) }}</span>
                <span class="text-xs font-semibold text-fq-text-muted">{{ categoryLabel(ticket.category) }}</span>
                @if (ticket.priority === 'high') {
                  <span class="fq-badge fq-badge-warning">Priorità alta</span>
                }
                <span class="ml-auto text-xs text-fq-text-muted">{{ formatDate(ticket.createdAt) }}</span>
              </div>
              <div class="text-sm font-bold text-fq-text">{{ ticket.title }}</div>
              @if (ticket.body) {
                <div class="mt-1 whitespace-pre-line text-sm text-fq-text-2">{{ ticket.body }}</div>
              }
              @if (ticket.dueDate) {
                <div class="mt-1 text-xs text-fq-text-muted">
                  <fa-icon [icon]="['fas', 'calendar']" aria-hidden="true"></fa-icon>
                  Scadenza prevista: {{ formatDate(ticket.dueDate) }}
                </div>
              }
              @if (ticket.resolution) {
                <div class="mt-2 rounded border-l-4 border-l-fq-success bg-fq-surface-muted px-3 py-2 text-sm text-fq-text-2">
                  <div class="text-xs font-bold uppercase text-fq-text-muted">Nota del team</div>
                  {{ ticket.resolution }}
                </div>
              }
              @if (ticket.resolvedAt) {
                <div class="mt-1 text-xs text-fq-text-muted">Gestita il {{ formatDate(ticket.resolvedAt) }}</div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</p-dialog>
